import * as types from '../../actions/actionTypes';

const defaultState = {
  teams: null,
  paginationTeams: null,
  teamCreated: false,
  infoteamCreated: null,
  teamEdited: false,
  memberJoined: false,
  message: null,
  imageUploadedUrl: '',
  teamSelected: null,
  teamMembers: [],
  send_invitation_data: null,
  send_invitation_status: null,
  send_invitation_message: '',
  updating: false,
  isLoadingTeam: true,
  teamsByCognito: null,
  joinedBounty: false,

  //change  name of member in team detail
  nameMemberSelectedToChange: '',
  changedNameMember: null,

  //upload project file in team portal GIF
  uploadingProject: false,
  fileUploadedProjectUrl: '',
  uploadedProject: null,

  sendRequestForProposal: null,

  //for vote favorite team
  campaign: null,
  votedCampaign: null,
  voting: null,
  voted: null,
  favoriteInfoVoted: null,
  bountiesOfTeam: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.CREATE_TEAM_SUCCESS:
      return { ...state, infoteamCreated: action.data, teamCreated: true };

    case types.JOIN_TEAM_SUCCESS:
      return { ...state, memberJoined: true };
    case types.JOIN_TEAM_FAILED:
      return { ...state, message: action.data };

    case types.UPLOAD_TEAM_IMAGE:
      return { ...state, updating: true };
    case types.UPLOAD_TEAM_IMAGE_SUCCESS:
      return { ...state, imageUploadedUrl: action.data, updating: false };
    case types.UPLOAD_TEAM_IMAGE_FAILED:
      return { ...state, updating: false };

    case types.OPEN_MODAL_TO_EDIT_TEAM:
      return { ...state, teamSelected: action.data };
    case types.CLOSE_MODAL_TO_EDIT_TEAM:
      return { ...state, teamEdited: false, teamCreated: false, imageUploadedUrl: '' };

    case types.EDIT_TEAM_SUCCESS:
      return { ...state, ...action.data, teamEdited: true };

    case types.SUBMIT_RESULT_SUCCESS:
      return { ...state, resultSubmitted: true };
    case types.SUBMIT_RESULT_FAILED:
      return { ...state, message: action.data };

    case types.GET_TEAM_SUCCESS:
      return { ...state, teams: action.data, paginationTeams: action.pagination };
    case types.GET_TEAM_MEMBERS_SUCCESS:
      return { ...state, teamMembers: action.data };

    case types.GET_TEAM_DETAIL:
      return { ...state, teamSelected: null, isLoadingTeam: true };
    case types.GET_TEAM_DETAIL_SUCCESS:
      return { ...state, teamSelected: action.data, isLoadingTeam: false };
    case types.GET_TEAM_DETAIL_FAILED:
      // return { ...state, teamSelected: null, isLoadingTeam: false };
      return { ...state, isLoadingTeam: false };

    case types.GET_TEAM_BY_COGNITOID_SUCCESS:
      return { ...state, teamsByCognito: action.data };

    case types.EDIT_DETAIL_TEAM_SUCCESS:
      return { ...state, teamSelected: action.data };

    case types.SEND_INVITATION:
      return { ...state, send_invitation_message: '', send_invitation_status: false };
    case types.SEND_INVITATION_SUCCESS:
      return { ...state, send_invitation_data: action.data, send_invitation_status: true };
    case types.SEND_INVITATION_FAILED:
      return { ...state, send_invitation_message: action.message, send_invitation_status: false };

    case types.CLOSE_MODAL_TO_SEND_INVITATION:
      return { ...state, send_invitation_status: false };

    case types.JOIN_BOUNTY_BY_TEAM_SELECTED:
      return { ...state, joinedBounty: false };
    case types.JOIN_BOUNTY_BY_TEAM_SELECTED_SUCCESS:
      return { ...state, joinedBounty: true };

    case types.LEAVE_BOUNTY_SUCCESS:
      return { ...state, joinedBounty: false, leftBounty: true };

    case types.OPEN_MODAL_TO_SHOW_SUBMISSION_TEAM:
      return { ...state, teamSelected: action.data };

    case types.CHANGE_NAME_MEMBER:
      return { ...state, nameMemberSelectedToChange: '', changedNameMember: false };
    case types.CHANGE_NAME_MEMBER_SUCCESS:
      return { ...state, nameMemberSelectedToChange: action.data, changedNameMember: true };
    case types.CHANGE_NAME_MEMBER_FAILED:
      return { ...state, changedNameMember: false };

    //upload project file in team portal GIF
    case types.UPLOAD_PROJECT_FILE:
      return { ...state, uploadingProject: true };
    case types.UPLOAD_PROJECT_FILE_SUCCESS:
      return { ...state, fileUploadedProjectUrl: action.data, uploadedProject: true, uploadingProject: false };
    case types.UPLOAD_PROJECT_FILE_FAILED:
      return { ...state, uploadedProject: false, uploadingProject: false };

    case types.SEND_REQUEST_FOR_PROPOSAL:
      return { ...state, sendRequestForProposal: null };
    case types.SEND_REQUEST_FOR_PROPOSAL_SUCCESS:
      return { ...state, sendRequestForProposal: true };
    case types.SEND_REQUEST_FOR_PROPOSAL_FAILED:
      return { ...state, sendRequestForProposal: false };

    case types.GET_VOTE_CAMPAIGN_SUCCESS:
      return { ...state, campaign: action.data };

    //For vote favorite team
    case types.VOTE_FOR_FAVORITE_TEAM:
      return { ...state, votedCampaign: null, voting: true };
    case types.VOTE_FOR_FAVORITE_TEAM_SUCCESS:
      return { ...state, votedCampaign: true, voting: false };
    case types.VOTE_FOR_FAVORITE_TEAM_FAILED:
      return { ...state, votedCampaign: false, voting: false };

    case types.CHECK_USER_VOTED_FOR_FAVORITE_TEAM_SUCCESS:
      return { ...state, favoriteInfoVoted: action.payload, voted: action.payload === null ? false : true };

    case types.GET_BOUNTIES_OF_TEAM_SUCCESS:
      return { ...state, bountiesOfTeam: action.data };

    case types.UPDATE_MEMBER_JOIN_BOUNTY_SUCCESS:
      return { ...state, updatedNewMemberJoinBounty: action.data };

    default:
      return state;
  }
};
